import {getUserId} from '../reducers';
import {errorHandler} from '../../core-utilities/rx-utils';
import {USER_COLLECTION} from '../domain/config';
import {buildInjector} from '../../_libs/angular-utils';
import {logger} from './logger';


// load angular dependencies:
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'FirebaseUtil',
]);

export function buildUserChannelSyncNotifier(channelName, logMessage) {
  return function syncNotifier(parentId, store) {
    const userId = getUserId(store.getState());
    return dependencies.FirebaseUtil
      .firebaseRef()
      .child(`${USER_COLLECTION}-meta/${userId}/channels/${channelName}`)
      .observe('value')
      .mapTo(null)
      /* (TODO: this if this issue applies to this list) Log list doesn't update correctly without a small delay */
      .delay(2500)
      .skip(1)
      .catch(errorHandler(logger, logMessage || `${channelName} syncNotifier`, null));
  };
}

export function buildParentChannelSyncNotifier(channelCollection, channelName, logMessage) {
  return function syncNotifier(parentId, store) {
    return dependencies.FirebaseUtil
      .firebaseRef()
      .child(`${channelCollection}-meta/${parentId}/channels/${channelName}`)
      .observe('value')
      .mapTo(null)
      /* (TODO: this if this issue applies to this list) Log list doesn't update correctly without a small delay */
      .delay(2500)
      .skip(1)
      .catch(errorHandler(logger, logMessage || `${channelName} syncNotifier`, null));
  };
}

/**
 * @param {String} collection
 * @param {String} [logMessage]
 * @return {function(String, Store): Observable<any>}
 */
export function buildInstanceSyncNotifier(collection, logMessage) {
  /**
   * @param {String} id
   * @param {Store} store
   * @return {Observable<any>}
   */
  return function syncNotifier(id, store) {
    return dependencies.FirebaseUtil
      .firebaseRef()
      .child(`${collection}-meta/${id}/channels/data`)
      .observe('value')
      .mapTo(null)
      .delay(2500)
      .skip(1)
      .catch(errorHandler(logger, logMessage || `${collection}/${id} syncNotifier`, null));
  };
}



// WEBPACK FOOTER //
// ./src/js/auth/utils/redux-lists.js